import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children"];
import React, { useContext } from 'react';
import { forwardRefAndName } from "../../../lib/forwardRefAndName";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { styles } from "../MiniModal.styles";
import { MiniModalDataTids } from "../MiniModal";

/**
 * Отступ между кнопками
 *
 * @visibleName MiniModal.Indent
 */
export var MiniModalIndent = forwardRefAndName('MiniModalIndent', function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-tid": MiniModalDataTids.indent,
    ref: ref,
    className: styles.actionsIndent(theme)
  }, rest));
});